import { Dropdown } from "primereact/dropdown";

// Box superior del diálogo de cierre: define dinámicamente la cantidad de
// documentos a emitir por tipo de documento (catálogo tipo_documento), entre
// 1 y el total de ítems del tipo (nuevos + existentes). No existen los modos
// "Separadas/Consolidadas": con la cantidad definida, cada ítem se asigna a
// uno de esos documentos y el backend infiere el estado de la distribución.
const BoxEscenarioDocumentos = ({
  catalogo,
  config,
  totalesPorCobro,
  onChangeConfig,
  disabled = false,
}) => {
  const tipos = Array.isArray(catalogo) ? catalogo : [];

  if (tipos.length === 0) {
    return (
      <div
        style={{
          background: "#f8f9fa",
          border: "1px solid #dee2e6",
          borderRadius: "6px",
          padding: "10px",
          marginBottom: "10px",
        }}
      >
        <span className="text-500 text-sm">
          Catálogo de tipos de documento no disponible.
        </span>
      </div>
    );
  }

  const configDe = (codigo) =>
    (Array.isArray(config) ? config : []).find((c) => c.codigo === codigo);

  const opcionesCantidad = (total) =>
    Array.from({ length: Math.max(total, 1) }, (_, idx) => ({
      label: `${idx + 1}`,
      value: idx + 1,
    }));

  return (
    <div
      style={{
        background: "#eef6ff",
        border: "1px solid #bfdbfe",
        borderRadius: "6px",
        padding: "12px",
        marginTop: "10px",
      }}
    >
      <div
        style={{
          fontWeight: 600,
          fontSize: "0.95rem",
          marginBottom: "4px",
        }}
      >
        Cantidad de documentos
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        {tipos.map((tipo) => {
          const codigo = tipo.codigo ?? tipo.descripcion;
          const descripcion = tipo.descripcion;
          const totales = totalesPorCobro?.[descripcion] ?? {
            total: 0,
            nuevos: 0,
            existentes: 0,
          };
          const estado = configDe(codigo) ?? { cantidadDocumentos: null };
          const total = totales.total ?? 0;

          return (
            <div
              key={codigo}
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "12px",
                background: "#ffffff",
                border: "1px solid #dbeafe",
                borderRadius: "6px",
                padding: "8px 12px",
              }}
            >
              <div style={{ minWidth: "170px", flex: "1 1 170px" }}>
                <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>
                  {descripcion}
                </div>
                <div style={{ fontSize: "0.8rem", color: "#64748b" }}>
                  {total} ítem{total === 1 ? "" : "s"}
                  {totales.nuevos ? ` · ${totales.nuevos} nuevo${totales.nuevos === 1 ? "" : "s"}` : ""}
                  {totales.existentes
                    ? ` · ${totales.existentes} vigente${totales.existentes === 1 ? "" : "s"}`
                    : ""}
                </div>
              </div>

              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span className="p-float-label mt-2 mb-3">
                  <Dropdown
                    value={
                      Number(estado.cantidadDocumentos) > 0
                        ? Number(estado.cantidadDocumentos)
                        : Math.max(total, 1)
                    }
                    options={opcionesCantidad(total)}
                    onChange={(e) =>
                      onChangeConfig(codigo, descripcion, {
                        cantidadDocumentos: e.value,
                      })
                    }
                    placeholder="Seleccionar"
                    disabled={disabled}
                    className="p-button-sm"
                    style={{ width: "150px" }}
                  />
                  <label>
                    Cant. Documentos:
                  </label>
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default BoxEscenarioDocumentos;